var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('simple-datatable',{attrs:{"title":"Liste des activités","add":_vm.add,"editRoute":"Edit Activity","data":_vm.activities,"footer":['#', 'Nom', ''],"searchFields":['id', 'name'],"defaultSort":"id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }